import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Song } from 'src/shared/models/song.model';
import { SongService } from 'src/shared/services/song.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public menuIsActive: boolean = false;
  public searchIsActive: boolean = false;

  constructor(private router: Router, private songService: SongService) { }

  ngOnInit(): void {
    // Make sure to collapse search on route changes.
    this.router.events.subscribe(() => {
      this.searchIsActive = false;
      this.menuIsActive = false;
    });
  }

  public searchResults: Song[] = [];

  public onChangeSearch($event): void {
    const searchQuery = $event.target.value;

    this.searchResults = this.songService.Get(searchQuery);
  }

  public onClickToggleSearch(searchField: HTMLInputElement): void {
    this.searchIsActive = !this.searchIsActive;

    if (this.searchIsActive) {
      searchField.focus();

      // Make sure to reset the search.
      searchField.value = '';
      this.searchResults = [];
    }


  }
}
